import { GfStoreDto } from "@swagger/typescript-fetch-goflyer";
import { GooglePlaceResult } from "../useStoreSearch";

export function getLatLngFromGooglePlace(
  place: GooglePlaceResult
): { lat: number; lng: number } | undefined {
  if (place.geometry && place.geometry.location) {
    const loc = place.geometry.location as any;
    let lat: number | undefined, lng: number | undefined;
    if (typeof loc.lat === "function" && typeof loc.lng === "function") {
      lat = loc.lat();
      lng = loc.lng();
    } else if (typeof loc.lat === "number" && typeof loc.lng === "number") {
      lat = loc.lat;
      lng = loc.lng;
    }
    if (
      typeof lat === "number" &&
      typeof lng === "number" &&
      isFinite(lat) &&
      isFinite(lng)
    ) {
      return { lat, lng };
    }
  }
  return undefined;
}

export function constructGoogleMapsUrl(
  lat: number,
  lng: number,
  placeName: string
): string {
  const encodedPlaceName = encodeURIComponent(placeName.replace(/ /g, "+"));
  return `https://www.google.com/maps/place/${encodedPlaceName}/@${lat},${lng},16z`;
}

export function extractLatLngFromGoogleMapUrl(
  googleMapUrl: string
): { lat: number; lng: number } | undefined {
  const match = googleMapUrl.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (match) {
    const lat = parseFloat(match[1]);
    const lng = parseFloat(match[2]);
    if (isFinite(lat) && isFinite(lng)) {
      return { lat, lng };
    }
  }
  return undefined;
}

export function formatStoreAddress(store: {
  street?: string;
  city?: string;
  province?: string;
  country?: string;
  zip?: string;
}): string {
  return [store.street, store.city, store.province, store.country, store.zip]
    .filter(Boolean)
    .join(", ");
}

export function getStoreLatLngFromStore(
  store: GfStoreDto
): { lat: number; lng: number } | undefined {
  if (store.googleMapUrl) {
    const latLng = extractLatLngFromGoogleMapUrl(store.googleMapUrl);
    if (latLng) return latLng;
  }

  if (
    store.location?.coordinates &&
    typeof store.location.coordinates[1] === "number" &&
    typeof store.location.coordinates[0] === "number" &&
    isFinite(store.location.coordinates[1]) &&
    isFinite(store.location.coordinates[0])
  ) {
    return {
      lat: store.location.coordinates[1],
      lng: store.location.coordinates[0],
    };
  }

  return undefined;
}

export const MAP_CONFIG = {
  containerStyle: {
    width: "100%",
    height: "100%",
    minHeight: 320,
    borderRadius: 12,
  },
  defaultCenter: { lat: 43.6532, lng: -79.3832 },
  defaultZoom: 14,
  selectedZoom: 16,
} as const;
